import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { App } from './App'

ReactDOM.createRoot(document.querySelector('#r-a-form-rental-damage-report')!).render(
    <StrictMode>
        <App />
    </StrictMode>,
)
